<div class="w-full" *ngIf="fields && addressFormGroup && addressFormGroupName">
    <form class="flex w-full flex-wrap contact-info-form-div" [formGroup]="addressFormGroup" autocomplete="nope">
        <!-- Contact First Name -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.contactFirstName">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'contact.first_name' |
                translate}}</label>
            <input type="text" formControlName="firstName"  autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'contact.first_name' | translate}}">
        </div>
        <!-- Contact Last Name -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.contactLastName">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'contact.last_name' |
                translate}}</label>
            <input type="text" formControlName="lastName"  autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'contact.last_name' | translate}}">
        </div>
        <!-- Contact Email -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.contactEmail">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'contactInfo.field.email.text' |
                translate}}</label>
            <input type="email" formControlName="email"  autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.email_placeholder' | translate}}">
            <p class="text-red-500 text-base mt-2 primary-font" *ngIf="showError('email')">
                {{'text.invalid_email_address' |
                translate}}</p>
        </div>
        <!-- Contact Phone Number-->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.contactPhone">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'contact.phone_number' |
                translate}}</label>
            <input type="text" formControlName="phone"  autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'contact.phone_number' | translate}}">
        </div>
        <!-- Street -->
        <!-- Adding conditional padding class and label if only street field is present in the form -->
        <div class="px-2  field-container-full-width" *ngIf="fields.street" [ngClass]="{'py-3': fields?.city}">
            <div class="flex space-x-2" *ngIf="!fields.hideAllLabel">
                <label class="block text-base font-medium text-gray-700" *ngIf="fields?.city">{{'contactInfo.field.street.text' | translate}}
                    <span class="mandatory-field" *ngIf="!optionalAddress">*</span>
                </label>
                <span *ngIf="fields.enablePickFromMap !== false && fields.enableMapsAutoComplete" class="text-primary-500 cursor-pointer text-base"
                    (click)="openMap()">
                    ({{'text.pick_from_map' | translate}})
                </span>
            </div>
            <input type="text" formControlName="street"
                *ngIf="fields.enableMapsAutoComplete"  autocomplete="nope"
                placeholder="{{'contactInfo.field.street.placeholder' | translate}}"
                #streetInput
                (focus)="onStreetInputFocus()"
                (blur)="onStreetInputBlur()"
                googleMapsAutocomplete
                [canTruncate]="fields.canTruncate ? fields.canTruncate : false"
                (autocompleteSelected)="onAutocompleteSelected($event)"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base">
            <input type="text" formControlName="street"  autocomplete="nope"
                *ngIf="!fields.enableMapsAutoComplete"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'contactInfo.field.street.placeholder' | translate}}">
            <p class="text-red-500 text-base mt-2 primary-font" *ngIf="showError('street')">
                {{'contactInfo.field.street.validText' |
                translate}}</p>
        </div>
        <!-- Landmark -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.landmark">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.landmark' |
                translate}}</label>
            <input type="text" formControlName="landmark" autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.landmark' | translate}}">
        </div>
        <!-- City -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.city">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.city' | translate}}
                <span class="mandatory-field" *ngIf="!optionalAddress">*</span>
            </label>
            <input type="text" formControlName="city" autocomplete="nope" (keyup)="emitRegionalChange($event, 'CITY', addressFormGroupName)"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.city' | translate}}">
            <p class="text-red-500 text-base mt-2 primary-font" *ngIf="showError('city')">
                {{'contactInfo.field.city.validText' |
                translate}}</p>
        </div>
        <!-- State -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.state">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.state_province' |
                translate}}</label>
            <input type="text" formControlName="state" autocomplete="nope" (keyup)="emitRegionalChange($event, 'STATE', addressFormGroupName)"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.state_province' | translate}}">
        </div>
        <!-- Country -->
        <div class="px-2 py-3  field-container-half-width" *ngIf="fields.country">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.country' |
                translate}}</label>
            <input type="text" formControlName="country" autocomplete="nope"
                [matAutocomplete]="countryAutocomplete"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.country' | translate}}">
            <mat-autocomplete #countryAutocomplete="matAutocomplete" class="zuper-scrollbar" [displayWith]="displayFn">
                <mat-option class="h-12 text-base primary-font" *ngFor="let option of filteredOptions | async"
                    [value]="option">
                    {{option.label}}
                </mat-option>
            </mat-autocomplete>
        </div>
        <!-- Zipcode -->
        <div class="px-2 py-3 field-container-half-width" *ngIf="fields.zipcode">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.zipcode' |
                translate}}</label>
            <input type="text" formControlName="zipcode" autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.zipcode' | translate}}">
        </div>
        <!-- Latitude -->
        <div class="px-2 py-3 field-container-half-width" *ngIf="fields.latitude && showCoordinatesField('latitude')">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.latitude' |
                translate}}</label>
            <input type="text" formControlName="latitude" autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.latitude' | translate}}">
        </div>
        <!-- Longitude -->
        <div class="px-2 py-3 field-container-half-width" *ngIf="fields.longitude && showCoordinatesField('longitude')">
            <label class="block text-base font-medium text-gray-700" *ngIf="!fields.hideAllLabel">{{'text.longitude' |
                translate}}</label>
            <input type="text" formControlName="longitude" autocomplete="nope"
                class="mt-1 block field-full-width rounded-md border border-gray-300 focus:border-indigo-500 bg-white shadow-sm px-3 py-3 leading-none text-base"
                placeholder="{{'text.longitude' | translate}}">
        </div>
    </form>
</div>